// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { linkListStyles } from "@tps/Overrides/Widgets/Basic/SocialLinks";
import { color } from "@tps/XDL/Utilities";
import { css } from "styled-components";

linkListStyles.socialLinkListWrapper = {
    css: css`
        width: 100%;
        gap: 20px;
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
    `,
};
linkListStyles.linkWrapper = {
    css: css``,
};
linkListStyles.link = {
    typographyProps: {
        color: "text.main",
    },
    css: css`
        position: relative;
        ${IconWrapper} {
            z-index: 1;
            margin: 0;
        }
        svg path {
            color: ${color("common.white")};
        }
        &:hover {
            svg path {
                fill: ${color("common.ui8")};
                color: ${color("common.ui8")};
            }

            &:after {
                content: " ";
                display: block;
                position: absolute;
                width: 22px;
                height: 22px;
                left: 1px;
                background: ${color("common.ui1")};
                z-index: 0;
            }
        }
    `,
};
